import { refreshPausedState } from 'store/modules/user-session/actions'

/** Don't re-hit /me more than once per this window when focus/visibility events cluster. */
export const PAUSED_REFRESH_THROTTLE_MS = 30 * 1000

type StoreLike = {
  dispatch: (action: unknown) => unknown
}

/**
 * Keeps the paused signal reasonably fresh without polling: re-fetches /me when the tab becomes
 * visible, the window regains focus, or a bfcache page is restored (`pageshow`). Throttled so
 * clustered focus events don't spam the BFF; the `refreshPausedState` thunk itself de-dupes
 * in-flight requests and fails open. Set up once at app bootstrap (main.js), so no teardown.
 */
export const setupPausedStateRefresh = (store: StoreLike): void => {
  let lastRefresh = 0

  const maybeRefresh = () => {
    // A `visibilitychange` firing for the hidden→ transition isn't a return-to-tab; skip it.
    if (document.visibilityState === 'hidden') return
    const now = Date.now()
    if (now - lastRefresh < PAUSED_REFRESH_THROTTLE_MS) return
    lastRefresh = now
    store.dispatch(refreshPausedState())
  }

  document.addEventListener('visibilitychange', maybeRefresh)
  window.addEventListener('focus', maybeRefresh)
  window.addEventListener('pageshow', maybeRefresh)
}
